import { LabelStyled } from './styles';

export const LabelThemed = LabelStyled;
